import { useDefaultELendsList } from '@/domain/euler/elends/useELendInfo'
import { E_LEND_CHAIN_ID } from '@/config/euler-contracts'
import { useMemo } from 'react'

// Re-export for backward compatibility
export const BORROW_VAULT_CHAIN_ID = E_LEND_CHAIN_ID

/**
 * Get list of eLend vaults that can be used for borrowing
 * Uses the same data source as eLend (indexer with onchain fallback)
 * This ensures we get all vaults that have collateral configured
 */
export function useVaultList() {
  // Fetch all eLend vaults (respects SHOW_ALL_ELEND_VAULTS)
  const { vaults: elendVaults, isPending, isError } = useDefaultELendsList(BORROW_VAULT_CHAIN_ID)

  // Extract vault addresses from eLend vaults
  const vaultList = useMemo(() => {
    return elendVaults.map((vault) => vault.address)
  }, [elendVaults])

  return {
    data: vaultList,
    isLoading: isPending,
    error: isError ? 'Failed to fetch vaults' : undefined,
  }
}
